import { render, staticRenderFns } from "./Configuraciones.vue?vue&type=template&id=f00928e6&scoped=true&"
import script from "./Configuraciones.vue?vue&type=script&lang=js&"
export * from "./Configuraciones.vue?vue&type=script&lang=js&"
import style0 from "./Configuraciones.vue?vue&type=style&index=0&id=f00928e6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f00928e6",
  null
  
)

export default component.exports